import { Injectable } from '@angular/core';
import { ReactiveProvider } from '../reactive-provider';
import { IEventOffer } from 'src/app/models/passculture.model';
import { HTTPTools } from 'src/app/etc/http-tools';

@Injectable()
export class PassCultureService extends ReactiveProvider<IEventOffer> {
    protected url = "pass-culture";

    getVenue(siret: string) {
        return this.httpClient.get(this.getUrl(`venues/${siret}`));
    }

    getEventOffer(id: string) {
        return this.httpClient.get<IEventOffer>(this.getUrl(`event-offer/${id}`));
    }

    getEventOfferImage(id: string) {
        return this.httpClient.get(this.getUrl(`event-offer/${id}/image`), { responseType: 'blob' });
    }

    syncEventOffer(id: string, data: any) {
        return this.httpClient.post<IEventOffer>(this.getUrl(`event-offer/${id}/sync`), data);
    }

    syncEventOfferImage(id: string, body: FormData) {
        HTTPTools.setNextContentType(null);
        return this.httpClient.post<IEventOffer>(this.getUrl(`event-offer/${id}/image`), body);
    }
}
